var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtworkIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.583 10.197a9.112 9.112 0 0 0-.423-.82l-1.998 5.427c-.077.203-.187.391-.328.556 2.196-.205 3.799-2.511 2.922-4.741a8.143 8.143 0 0 0-.173-.422Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.114 5.308a9.2 9.2 0 0 0-5.458 12.078c.012.025.02.05.033.074 1.051 2.57 4.591 2.91 6.129.597a6.542 6.542 0 0 1 3.028-2.459c.04-.015.079-.027.118-.042a2.422 2.422 0 0 1 1.51-1.35 1.902 1.902 0 0 1 .177-.855l3.093-6.695a9.219 9.219 0 0 0-8.63-1.348ZM6.715 15.52a1.565 1.565 0 1 1 0-3.13 1.565 1.565 0 0 1 0 3.13Zm1.957-4.5a1.565 1.565 0 1 1 0-3.131 1.565 1.565 0 0 1 0 3.13Zm4.696-1.37a1.565 1.565 0 1 1 0-3.13 1.565 1.565 0 0 1 0 3.13Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.404 4.426a.727.727 0 0 0-.939.367l-4.103 8.886a1.119 1.119 0 0 0 .209 1.244 1.653 1.653 0 0 0-1.903.975c-.633 1.53.369 2.201-.265 3.732 0 0 2.375-.17 3.326-2.465a1.65 1.65 0 0 0-.49-1.912 1.115 1.115 0 0 0 1.19-.719l3.38-9.186a.727.727 0 0 0-.405-.922Z",
    fill: "#fff"
  })));
};
export { SvgArtworkIcon as ReactComponent };